import { useGlobalSpinnerContext } from 'app/providers/GlobalSpinner';

export const useGlobalSpinner = () => {
  const { show, hide } = useGlobalSpinnerContext();

  return {
    showSpinner: show,
    hideSpinner: hide,
  };
};
